interface KaizenMonthlySavingsList {
    calendarMonthID: number;
    costPerUnitSavings: number;
    kaizenAccountId: number;
    kaizenMonthlySavingId: number;
    monthlySavings: number;
    monthHead:string;
    capacity:number;
    standardRate:number;
    workingDays:number;
    numberOfShifts:number;
    workingHours:number;
    processReduction:number;
    twtReduction:number;
 
}

export class PRKaizenMonthlySavingsList{
    public pageNumber!: number;
    public pageSize!:number;
    public succeeded!:boolean
    public message!:string;
    public errors!:string;
    public data!:KaizenMonthlySavingsList[];
}